import React from 'react'
import { Send, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Textarea } from '@/components/ui/textarea'
import { Dialog, DialogContent, DialogClose, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { useTheme } from '@/context/ThemeContext'

interface ExpandedComposeDialogProps {
  isOpen: boolean
  onClose: () => void
  input?: string
  onInputChange: (value: string) => void
  onSend: () => void
  isProcessing: boolean
}

const ExpandedComposeDialog: React.FC<ExpandedComposeDialogProps> = ({
  isOpen,
  onClose,
  input = '',
  onInputChange,
  onSend,
  isProcessing,
}) => {
  const { isDarkMode } = useTheme()

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSend()
    }
  }

  const handleSend = () => {
    onSend()
    onClose()
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="w-[90vw] max-w-[800px] h-[70vh] p-6">
        <div className="flex flex-col h-full">
          <DialogHeader className="flex flex-col space-y-8 pb-3">
            <DialogTitle>Compose Message</DialogTitle>
          </DialogHeader>
          <div className="flex-1 bg-gray-100 rounded-lg p-4 overflow-hidden my-3">
            <Textarea
              value={input}
              onChange={(e) => onInputChange(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Compose your message..."
              className={`w-full h-full bg-transparent border-none focus-visible:ring-0 focus-visible:ring-offset-0 resize-none overflow-auto min-h-[300px] ${
                isDarkMode ? 'text-white placeholder:text-gray-400' : ''
              }`}
              disabled={isProcessing}
            />
          </div>
          <div className="flex justify-between items-center mt-3">
            <DialogClose asChild>
              <Button variant="outline">Close</Button>
            </DialogClose>
            <Button onClick={handleSend} disabled={isProcessing || !input.trim()}>
              <Send size={18} className="mr-2" />
              Send
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ExpandedComposeDialog
